/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reading_File_ContentsInputs */



/**
* | output |
* | --- |
* | "Reading file contents..." |
*
* @param {Reading_File_ContentsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const reading_file_contents = /** @type {((inputs?: Reading_File_ContentsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reading_File_ContentsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lecture du contenu du fichier...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateiinhalt wird gelesen...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lettura del contenuto del file...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Чтение содержимого файла...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Leyendo el contenido del archivo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在读取文件内容...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルの内容を読み込んでいます...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल की सामग्री पढ़ी जा रही है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lendo o conteúdo do arquivo...")
	return /** @type {LocalizedString} */ ("Reading file contents...")
});